"use strict";

/**
 * @classdesc
 * Entfernt alle deaktivierten Layer des Layertree.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action.layer
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} options.map Referenz auf die Karte
 */
gc.gis.action.layer.RemoveUnvisibleLayer = function(options)
{
	gc.gis.action.GCAbstractAction.call(this);

	/**
	 * @inheritdoc
	 */
	this.func = this.doExecute;
	/**
	 * @inheritdoc
	 */
	this.args = [options.map];
};
gc.gis.action.layer.RemoveUnvisibleLayer.prototype = Object.create(gc.gis.action.GCAbstractAction.prototype);

/**
 * Entfernt alle deaktivierten Layer des Layertree.
 * <em>Hinweis: Diese Funktion sollte nicht manuell aufgerufen werden.</em>
 *
 * @public
 * @param {gc.gis.map.GCMapView} map Referenz auf die Karte
 * @see gc.gis.action.GCAbstractAction#execute
 */
gc.gis.action.layer.RemoveUnvisibleLayer.prototype.doExecute = function(map)
{
	var layers = map.getLayersRecursive(function(layer) {
		return !layer.isVisible();
	});

	for(var i=0; i<layers.length; i++)
	{
		var parent_layer = layers[i].getParent();
		if(parent_layer)
		{
			parent_layer.removeLayer(layers[i]);
		}
		else
		{
			throw new gc.gis.error.GCError('Layer not attached to a parent');
		}
	}
};